import { Action } from '@ngrx/store';

export const RESET_ACCOUNT_DATA = '[App] Reset Account Data';

export class ResetAccountData implements Action {
  readonly type = RESET_ACCOUNT_DATA;
}

export type AppAction = ResetAccountData;

